<div>
    <form [formGroup]="taksGroup" autocomplete="off">
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> T&iacute;tulo:</mat-label>
                    <textarea aria-label="Título:" formControlName='tituloCtrl' maxlength="200" matInput placeholder="Titulo:"
                        [(ngModel)]="objetoTask.nombre"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-label> Descripci&oacute;n:</mat-label>
                    <textarea aria-label="Descripción:" formControlName='descripcionCtrl' maxlength="400" matInput placeholder="Descripción"
                        [(ngModel)]="objetoTask.descripcion"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <mat-form-field>
                    <mat-label> Estatus</mat-label>
                    <mat-select formControlName='estatusCtrl' placeholder="Estatus" required
                        [(ngModel)]="objetoTask.estatus">
                        <mat-option *ngFor="let prob of estatus" [value]="prob.valor">
                            {{ prob.valor }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-4">
                <mat-form-field>
                    <mat-label> Tiempo estimado (Horas)</mat-label>
                    <input aria-label="Tiempo estimado (Horas)" formControlName='tiempoEstimadoCtrl' maxlength="4" matInput soloNumero
                        placeholder="Tiempo Estimado" [(ngModel)]="objetoTask.tiempoEstimado">
                </mat-form-field>
            </div>
            <div class="col-sm-4">
                <mat-form-field>
                    <mat-label> Tiempo real (Horas)</mat-label>
                    <input aria-label="Tiempo real (Horas)" formControlName='tiempoRealCtrl' maxlength="4" matInput soloNumero placeholder="Tiempo Real"
                        [(ngModel)]="objetoTask.tiempoReal">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <mat-form-field appearance="outline">
                    <mat-label> Responsable</mat-label>
                    <mat-select name="empleadoAutoriza" placeholder="Elige empleado" formControlName="responsableCtrl"
                        required [(ngModel)]="objetoTask.responsable">
                        <mat-option *ngFor="let item of listaDEmpleados"
                        [value]="item.usuario.id">{{item.persona.nombreCompleto}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-sm-4">
                <mat-form-field>
                    <mat-label> Clasificaci&oacute;n</mat-label>
                    <input aria-label="Clasificación" formControlName='clasificacionCtrl' maxlength="100" matInput placeholder="Clasificación: "
                        [(ngModel)]="objetoTask.clasificacion">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <mat-form-field>
                    <mat-label> Tipo</mat-label>
                    <mat-select formControlName='tipoCtrl' placeholder="Tipo de tarea" required
                        [(ngModel)]="objetoTask.tipo">
                        <mat-option *ngFor="let prob of tipoTarea" [value]="prob.tipo">
                            {{ prob.tipo }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-sm-6">
                <mat-form-field *ngIf="taksGroup.get('tipoCtrl').value === 'CU'">
                    <mat-label> Seleccione el caso de uso</mat-label>
                    <mat-select formControlName='idtipo' placeholder="Seleccionar CU" required
                        [(ngModel)]="objetoTask.idtipo">
                        <mat-option *ngFor="let cu of listaCu" [value]="cu.id">
                            {{ cu.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="taksGroup.get('tipoCtrl').value === 'HU'">
                    <mat-label> Seleccione la historia de usuario</mat-label>
                    <mat-select formControlName='idtipo' placeholder="Seleccionar HU" required
                        [(ngModel)]="objetoTask.idtipo">
                        <mat-option *ngFor="let hu of listaHu" [value]="hu.id">
                            {{ hu.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <button mat-button class="btn  btn-success" (click)="guardarTask()" [disabled]="taksGroup.invalid">
                    Guardar <i class='material-icons'> save </i>
                </button>
            </div>
        </div>
    </form>
</div>